import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { request, axios } from '@/utils/request'
import '@/assets/css/base.less'
import 'swiper/css/swiper.css'
import less from 'less'
Vue.use(less)
Vue.use(ElementUI);
Vue.config.productionTip = false
Vue.prototype.$request = request
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
